import { useState } from "react";
import * as moment from "moment";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import { useUserContext } from "store/contexts/userContext";
import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import UserDefaultAvatar from "assets/img/user.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom";
import ShowAllRecognizedMembers from "components/ShowAllRecognizedMembers";
import LazyLoadImage from "components/LazyLoadImage";

export default ({ listTask }) => {
  let history = useHistory();
  const { user } = useUserContext();
  const { addToast } = useToasts();
  const [countUserTag] = useState(listTask?.tagged_users?.length);
  const [timeDifference] = useState(moment(listTask.created_at).fromNow());
  const [checked, setChecked] = useState(false);
  const { team } = useTeamContext();
  const { updateTask } = useTimelineContext();
  const [tagUserDescription] = useState(checkUserTag);
  const [isUserTagged] = useState(checkUserTagg);
  const [islistAdmin] = useState(checklistAdmin);
  const iconStyle = {
    width: "17px",
    height: "17px",
  };

  function checkUserTag() {
    if (countUserTag === 0) {
      return <>All</>;
    }

    let isUserTagged = listTask?.tagged_users.some(
      (taguser) => taguser?.id === user?.id
    );

    let displayUser = isUserTagged ? "You" : listTask.tagged_users[0].full_name;

    if (countUserTag > 1) {
      var countUser = ` and ${countUserTag - 1}`;
      var otherUser = countUserTag < 3 ? " other" : " others";
      var result = countUser + otherUser;
    }

    return (
      <>
        {displayUser}
        {result}
      </>
    );
  }

  let moodIcon = null;

  const updateMyTask = async () => {
    try {
      await TeamService.updateTodoListTask(
        team.id,
        listTask.todo_list_id,
        listTask.id,
        {
          status_id: 2,
        }
      );

      const taskCopy = { ...listTask };

      taskCopy.status_id = 2;

      updateTask(taskCopy);
      setChecked(false);
      addToast("Task is completed. ", { appearance: "success" });
    } catch (e) {
      console.log(e);
    }
  };

  function checkUserTagg() {
    if (listTask?.tagged_users.length !== 0) {
      return listTask?.tagged_users.some((taguser) => taguser?.id === user?.id);
    }
    return true;
  }

  function checklistAdmin() {
    if (listTask?.user?.id === user?.id) {
      return true;
    }
    if ([2, 3].includes(team.role_id)) {
      return true;
    }
    return false;
  }

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <>
      <div className="post-header">
        <div className="img_user">
          <LazyLoadImage
            onClickFunction={() => showUserProfile(listTask?.user?.id)}
            style={{ cursor: "pointer" }}
            imageClassName="userAvatar"
            imageWrapperClassName="userAvatar"
            image={listTask?.user?.avatar ?? UserDefaultAvatar}
            alt={`${listTask?.user?.full_name}`}
            key={`${listTask?.user?.full_name}`}
          />
          {!!moodIcon && <img src={moodIcon} alt="moodIcon" />}
          <div className="userInformation">
            <span>
              <span className="post_uname"> {listTask?.user?.full_name}</span>
            </span>
            <span className="post_time">Posted {timeDifference}</span>
          </div>
        </div>
        <div className="p-h-right">
          {!checked &&
            listTask.status_id === 1 &&
            (isUserTagged || islistAdmin) && (
              <div
                className="rightTaskHeader"
                style={{ color: "red" }}
                onClick={() => setChecked(true)}
              >
                Mark as done
                <FontAwesomeIcon style={iconStyle} icon={faSquare} />
              </div>
            )}
          {checked && listTask.status_id === 1 && (
            <div className="rightTaskHeader" style={{ color: "red" }}>
              Mark as done
              <FontAwesomeIcon style={iconStyle} icon={faCheckSquare} />
            </div>
          )}
          {listTask.status_id === 2 && (
            <div className="rightTaskHeader" style={{ color: "green" }}>
              Completed
            </div>
          )}
        </div>
      </div>
      <div className="assigned-task mt-3">
        <span className="color-light">
          {"Assigned to: "}
          <ShowAllRecognizedMembers
            isForwarded={listTask?.is_forwarded}
            team={team}
            post={false}
            heading={"Tag Members"}
            description={tagUserDescription}
            tagged_users={listTask?.tagged_users}
            countUserTag={countUserTag}
          />
          <span className="p-l-r-10">|</span>Priority:{" "}
        </span>
        {listTask.is_forwarded && (
          <div className="sharedText">
            <LazyLoadImage
              style={{ cursor: "pointer" }}
              onClickFunction={() => showUserProfile(listTask?.user?.id)}
              image={listTask?.user?.avatar ?? UserDefaultAvatar}
              key={`${listTask?.user?.full_name}`}
              alt={`${listTask?.user?.full_name}`}
              imageClassName={"sharedImg"}
            />
            <span style={{ paddingLeft: "1px" }}>
              Shared By {listTask?.user?.full_name ?? "undefined"} from{" "}
              {listTask?.original_todoList_item?.team?.name ?? "undefined"}
            </span>
          </div>
        )}
        {listTask.priority && (
          <span className="text-danger fw-600">{listTask?.priority}</span>
        )}
        {!listTask.priority && (
          <span className="text-primary fw-600">None</span>
        )}
        <span className="color-light">
          <span className="p-l-r-10">|</span>Due date:{" "}
          {listTask?.due_date &&
            moment(listTask?.due_date).format("MM/DD/YYYY")}
          {!listTask?.due_date && "Unlimited"}
        </span>
      </div>
      <Modal
        showCloseIcon={false}
        open={checked}
        onClose={() => setChecked(false)}
        center
      >
        <div style={{ maxWidth: "498px" }}>
          <h2 className="taskConfirmHeading">Are you sure</h2>
          <h6 className="taskConfirmContent">
            Do you want to complete this task? This process can't be undone.
          </h6>
          <div className="taskConfirmButton">
            <Button
              onClick={() => {
                setChecked(false);
              }}
              buttonClass="small-btn me-2"
            >
              Cancel
            </Button>
            <Button buttonClass="small-accept-btn " onClick={updateMyTask}>
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
